<template>
  <p>Welcome!</p>
</template>
<script setup lang="ts">
</script>
<style scoped>
</style>
